var _defs, _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleTickColorable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .colorable-circle-class {\n        fill: #0099e6;\n        stroke: #0099e6;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3.1px;\n      }\n\n      .tick_x0020_white {\n        fill: #fff;\n        stroke: none;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "colorable-circle-class",
    x: 5.3,
    y: 5.3,
    width: 39.5,
    height: 39.5,
    rx: 19.7,
    ry: 19.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tick_x0020_white",
    d: "M21,37.4l-8.4-7.7c-.8-.8-.9-2-.1-2.9l1.7-1.9c.8-.8,2-.9,2.9-.1l4.5,4.1,10.6-16c.6-.9,1.9-1.2,2.8-.5l2.1,1.4c.9.6,1.2,1.9.5,2.8l-13.6,20.4c-.7,1-2.1,1.2-3,.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTickColorable);
export default __webpack_public_path__ + "static/media/circle_tick_colorable.16267c56fc55bed9f13c861beb4bd7ad.svg";
export { ForwardRef as ReactComponent };